<template>
  <div class="loader mx-auto text-xs-center" v-resize="calculateStyle">
    <div class="backdrop" />
    <v-progress-linear class="progress ma-auto" :style="style" :indeterminate="true" />
  </div>
</template>

<script>
import { propToBool } from '../../../libraries/common';
export default {
  noExport: true,
  props: ['fixed'],
  data() {
    return {
      style: null,
    };
  },
  methods: {
    calculateStyle() {
      if (propToBool(this.fixed)) {
        var box = this.$el.getBoundingClientRect();
        var documentBox = document.body.getBoundingClientRect();
        var bottom = Math.min(box.bottom, documentBox.bottom);
        this.style = {
          top: `${(bottom - box.top) / 2}px`,
        };
      }
    },
  },
  watch: {
    fixed() {
      this.calculateStyle();
    },
  },
  mounted() {
    this.calculateStyle();
  },
}
</script>

<style lang="scss" scoped>
.loader {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;

  .backdrop {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    opacity: 0.5;
  }

  .progress {
    position: absolute;
    top: calc(50% - 5px);
    left: 15%;
    width: 70%;
  }
}
</style>